/**
 * Represents the restriction options for a [[FilmAdvanceBookingPeriod]].
 */
export var FilmAdvanceBookingPeriodRestriction;
(function (FilmAdvanceBookingPeriodRestriction) {
    /**
     * The [[FilmAdvanceBookingPeriod]] has no restrictions.
     */
    FilmAdvanceBookingPeriodRestriction["None"] = "None";
    /**
     * Access to a [[MemberReward]] with the specified [[MemberRewardFilmAdvanceBookingPeriod.rewardId]] is required.
     *
     * @remarks
     * Redemption of the [[MemberReward]] is not required, and therefore the [[Reward.balanceCost]],
     * [[Reward.limitPerOrder]] and [[MemberReward.availableQuantity]] can be ignored.
     */
    FilmAdvanceBookingPeriodRestriction["MemberReward"] = "MemberReward";
})(FilmAdvanceBookingPeriodRestriction || (FilmAdvanceBookingPeriodRestriction = {}));
//# sourceMappingURL=film-advance-booking-period-restriction.js.map